module.exports = __webpack_public_path__ + "static/assets/bc147ee8750d399b4cdd4659713d68d3.png";